"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = Profile;
var _react = _interopRequireDefault(require("react"));
var _Avatar = _interopRequireDefault(require("@mui/material/Avatar"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Stack = _interopRequireDefault(require("@mui/material/Stack"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _theme = _interopRequireDefault(require("../theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Item = (0, _styles.styled)(_Box.default)(function (_ref) {
  var theme = _ref.theme;
  return _objectSpread(_objectSpread({}, theme.typography.body1), {}, {
    alignSelf: "flex-start",
    textAlign: "center",
    lineHeight: ".5rem",
    fontSize: "1rem"
  });
});
function Profile(_ref2) {
  var profile = _ref2.profile;
  var username = profile.username,
    network_name = profile.network_name;
  var Username = function Username() {
    var prefix = network_name === "twitter" ? "@" : "";
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "".concat(prefix).concat(username));
  };
  return /*#__PURE__*/_react.default.createElement(_Stack.default, {
    sx: {
      padding: 2,
      marginTop: "1rem"
    },
    spacing: 0,
    minWidth: "5.75rem"
  }, /*#__PURE__*/_react.default.createElement(Item, {
    sx: {
      alignSelf: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    alt: profile["name"],
    src: profile["avatar_url"],
    sx: {
      width: "5rem",
      height: "5rem"
    }
  })), /*#__PURE__*/_react.default.createElement(Item, {
    sx: {
      flexWrap: "nowrap",
      my: ".5rem",
      maxWidth: "5rerm",
      flexGrow: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    textAlign: "left",
    lineHeight: "1.1rem",
    variant: "subtitle1",
    flexWrap: "nowrap"
  }, profile["name"])), username && /*#__PURE__*/_react.default.createElement(Item, {
    sx: {
      fontSize: "1rem",
      color: _theme.default.palette.text.secondary
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    lineHeight: ".5rem",
    fontSize: "1rem",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(Username, null))));
}